import { render, staticRenderFns } from "./PersonalModal.vue?vue&type=template&id=56f4b77c&"
import script from "./PersonalModal.vue?vue&type=script&lang=js&"
export * from "./PersonalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports